export default class VideoModalController {
  /* @ngInject*/
  constructor(selectedVideo, selectedYear, $uibModalInstance, $compile, $scope) {
    // Assign injected values to scope
    this.$uibModalInstance = $uibModalInstance;
    this.$compile = $compile;
    this.$scope = $scope;
    this.video = selectedVideo;
    this.videoToPlay = selectedYear;
  }

  closeModal() {
    this.$uibModalInstance.close();
  }

  playVideo(video) {
    console.log(video);
    const popoverEmbedCode = `<video width="100%" controls autoplay>
    <source src="../../assets/videos/${video.fileName}" type="video/mp4"></video>`;
    let compiledeHTML = this.$compile(popoverEmbedCode)(this.$scope);
    $('#modal-video-template').fadeOut(500, () => {
      $('#modal-video-template').empty();
    });
    $('#modal-video-template').fadeIn(500, () => {
      $('#modal-video-template').append(compiledeHTML);
    });
  }

}



// WEBPACK FOOTER //
// ./client/components/modal/video-popup/modal.component.js